(function (window, document) {
  'use strict';

  if (window.RealseeUtmFlow) {
    return;
  }

  var STORAGE_KEY = 'realsee_utm_flow';
  var UTM_KEY_PATTERN = /^utm_/i;
  var PAID_PARAM_NAMES = {
    gclid: true,
    gbraid: true,
    wbraid: true,
    dclid: true,
    gad_source: true,
    gad_campaignid: true,
    fbclid: true
  };
  var REDIRECT_PARAM_NAMES = {
    q: true,
    variant: true,
    selling_plan: true,
    quantity: true,
    sort_by: true,
    type: true,
    section_id: true,
    page: true,
    view: true,
    discount: true,
    locale: true,
    locale_code: true,
    country: true,
    country_code: true,
    language: true,
    'options[prefix]': true
  };

  function isTrackingParam(key) {
    return UTM_KEY_PATTERN.test(key) || PAID_PARAM_NAMES[String(key).toLowerCase()] === true;
  }

  function isRedirectParam(key) {
    var normalizedKey = String(key).toLowerCase();

    return (
      isTrackingParam(normalizedKey) ||
      REDIRECT_PARAM_NAMES[normalizedKey] === true ||
      normalizedKey.indexOf('filter.') === 0
    );
  }

  function getTrackingParamKey(key) {
    return String(key).toLowerCase();
  }

  function isOwnedHost(hostname) {
    var host = String(hostname || '').toLowerCase();

    return host === 'realsee.ai' || host.slice(-'.realsee.ai'.length) === '.realsee.ai';
  }

  function readTrackingParams(url) {
    var params = new URL(url, window.location.href).searchParams;
    var result = {};

    params.forEach(function (value, key) {
      var normalizedKey = getTrackingParamKey(key);

      if (isTrackingParam(normalizedKey) && value !== '' && !Object.prototype.hasOwnProperty.call(result, normalizedKey)) {
        result[normalizedKey] = value;
      }
    });

    return result;
  }

  function readStoredParams() {
    try {
      var stored = JSON.parse(window.sessionStorage.getItem(STORAGE_KEY) || '{}');
      var result = {};

      Object.keys(stored).forEach(function (key) {
        var normalizedKey = getTrackingParamKey(key);

        if (isTrackingParam(normalizedKey) && typeof stored[key] === 'string' && stored[key] !== '') {
          result[normalizedKey] = stored[key];
        }
      });

      return result;
    } catch (error) {
      return {};
    }
  }

  function formatDecoratedHref(href, target) {
    var queryIndex = href.search(/[?#]/);
    var path = queryIndex === -1 ? href : href.slice(0, queryIndex);
    var isRelativeReference =
      href.charAt(0) === '?' ||
      href.charAt(0) === '.' ||
      (href.charAt(0) !== '/' && !/^[a-z][a-z0-9+.-]*:/i.test(href));

    if (href.charAt(0) === '/' && href.charAt(1) !== '/') {
      return target.pathname + target.search + target.hash;
    }

    if (isRelativeReference) {
      return (href.charAt(0) === '?' ? '' : path) + target.search + target.hash;
    }

    return target.toString();
  }

  function storeParams(params) {
    try {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(params));
    } catch (error) {
      return;
    }
  }

  function getTrackedParams() {
    var params = readStoredParams();
    var currentParams = readTrackingParams(window.location.href);

    Object.keys(currentParams).forEach(function (key) {
      params[key] = currentParams[key];
    });

    storeParams(params);
    return params;
  }

  function addParamsToHref(href, params) {
    if (
      !href ||
      href === '#' ||
      href.charAt(0) === '#' ||
      /^(?:javascript|mailto|tel|data|blob):/i.test(href) ||
      Object.keys(params).length === 0
    ) {
      return href;
    }

    var target;

    try {
      target = new URL(href, window.location.href);
    } catch (error) {
      return href;
    }

    if (!/^https?:$/.test(target.protocol) || !isOwnedHost(target.hostname)) {
      return href;
    }

    var changed = false;

    Object.keys(params).forEach(function (key) {
      var hasExistingKey = false;

      target.searchParams.forEach(function (value, existingKey) {
        if (getTrackingParamKey(existingKey) === key) {
          hasExistingKey = true;
        }
      });

      if (!hasExistingKey) {
        target.searchParams.set(key, params[key]);
        changed = true;
      }
    });

    if (!changed) {
      return href;
    }

    return formatDecoratedHref(href, target);
  }

  function getSafeRedirectUrl(href) {
    var originalHref = href || window.location.href;
    var target = new URL(originalHref, window.location.href);
    var unknownKeys = [];

    target.searchParams.forEach(function (value, key) {
      if (!isRedirectParam(key)) {
        unknownKeys.push(key);
      }
    });

    unknownKeys.forEach(function (key) {
      target.searchParams.delete(key);
    });

    return addParamsToHref(formatDecoratedHref(originalHref, target), getTrackedParams());
  }

  function decorateLink(element, attribute, params) {
    var href = element.getAttribute(attribute);
    var nextHref = addParamsToHref(href, params);

    if (nextHref !== href) {
      element.setAttribute(attribute, nextHref);
    }
  }

  function decorateLinks(params, root) {
    if (!root || typeof root.querySelectorAll !== 'function') {
      return;
    }

    root.querySelectorAll('a[href], form[action]').forEach(function (element) {
      decorateLink(element, element.tagName === 'FORM' ? 'action' : 'href', params);
    });
  }

  function decorateUrl(href) {
    return addParamsToHref(href, getTrackedParams());
  }

  function start() {
    var params = getTrackedParams();

    decorateLinks(params, document);

    document.addEventListener('click', function (event) {
      var target = event.target;
      var anchor = target && typeof target.closest === 'function' ? target.closest('a[href]') : null;
      var form = target && typeof target.closest === 'function' ? target.closest('form[action]') : null;

      if (anchor) {
        decorateLink(anchor, 'href', params);
      } else if (form) {
        decorateLink(form, 'action', params);
      }
    }, true);

    if (typeof MutationObserver === 'function') {
      new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          Array.prototype.forEach.call(mutation.addedNodes, function (node) {
            if (node.nodeType === 1) {
              if (node.matches && node.matches('a[href]')) {
                decorateLink(node, 'href', params);
              } else if (node.matches && node.matches('form[action]')) {
                decorateLink(node, 'action', params);
              }
              decorateLinks(params, node);
            }
          });
        });
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  window.RealseeUtmFlow = {
    getTrackedParams: getTrackedParams,
    decorateUrl: decorateUrl,
    getSafeRedirectUrl: getSafeRedirectUrl
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})(window, document);
